import { Sprite, Texture } from 'pixi.js';

import { Shared } from '../../App';
import { Entity25D } from '../../display/odie25d/Entity25D';

export class BoostEffectEntity extends Entity25D
{
    public sprite: Sprite;
    public frames: Texture[];
    public playbackPosition: number;
    public rate = 0.5;

    constructor()
    {
        super({ view: new Sprite() });

        this.sprite = this.view as Sprite;
        this.sprite.anchor.set(0.5);
        this.playbackPosition = 0;
        this.frames = Shared.assets.getFrames('speedboost-');
        this.step(0);
    }

    public reset(): void
    {
        this.playbackPosition = 0;
    }

    public step(delta = 1): boolean
    {
        this.playbackPosition += delta * this.rate;
        const frameIndex = Math.floor(this.playbackPosition % this.frames.length);

        this.sprite.texture = this.frames[frameIndex];

        return frameIndex >= this.frames.length - 1;
    }
}
